import { render } from "./MemberForm.vue?vue&type=template&id=31d1b033&scoped=true"
import script from "./MemberForm.vue?vue&type=script&lang=js"
export * from "./MemberForm.vue?vue&type=script&lang=js"

import "./MemberForm.vue?vue&type=style&index=0&id=31d1b033&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d1b033"]])

export default __exports__